import { useEffect } from "react";
import { Nav } from "react-bootstrap";
import { localActions, useLocal } from "../util/local.ts";
import { toWorker } from "../util/toWorker.ts";

// Top-right account display. Shows the multiplayer account when signed in,
// otherwise falls back to the standard Basketball GM account links.
export const MpUserBlock = ({ username }: { username: string | undefined }) => {
	const { mpEmail } = useLocal(["mpEmail"]);

	useEffect(() => {
		// Per-tab initialization; afterwards the worker pushes updates on every
		// auth change via updateLocal.
		const run = async () => {
			const session = await toWorker("main", "mpGetSession", undefined);
			localActions.update({ mpEmail: session?.email });
		};
		void run();
	}, []);

	if (mpEmail) {
		return (
			<Nav.Link href="/multiplayer" aria-label="Multiplayer account">
				<span className="glyphicon glyphicon-user" />{" "}
				<span className="d-none d-lg-inline">{mpEmail.split("@")[0]}</span>
			</Nav.Link>
		);
	}

	if (username) {
		return (
			<Nav.Link href="/account" aria-label="Account">
				<span className="glyphicon glyphicon-user" />{" "}
				<span className="d-none d-lg-inline">{username}</span>
			</Nav.Link>
		);
	}

	return (
		<Nav.Link href="/multiplayer" aria-label="Sign in">
			<span className="glyphicon glyphicon-user" />{" "}
			<span className="d-none d-lg-inline">Sign In</span>
		</Nav.Link>
	);
};
